export default function pluralise(count, noun, suffix = 's') {
  return `${noun}${count === 1 ? '' : suffix}`;
}
